import { X, ExternalLink } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export const VenmoModal = ({ open, onOpenChange, packageInfo }) => {
  const venmoUsername = "Elise-Redfield";
  const venmoLink = "https://venmo.com/u/Elise-Redfield";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="bg-[#0a0a0a] border border-white/10 max-w-md p-0 overflow-hidden"
        data-testid="venmo-modal"
        aria-describedby="venmo-modal-description"
      >
        {/* Header */}
        <div className="bg-[#008CFF] p-6">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl tracking-wide uppercase text-white text-center">
              Pay with Venmo
            </DialogTitle>
            <DialogDescription id="venmo-modal-description" className="sr-only">
              Complete your payment via Venmo to @Elise-Redfield
            </DialogDescription>
          </DialogHeader>
        </div>

        {/* Content */}
        <div className="p-8">
          {/* Package Info */}
          {packageInfo && (
            <div className="mb-8 text-center">
              <p className="font-body text-sm text-white/50 mb-2">Selected Package</p>
              <p className="font-heading text-lg tracking-wide uppercase text-white mb-1">
                {packageInfo.name}
              </p>
              <p className="font-heading text-3xl font-bold text-white">
                {packageInfo.price}
              </p>
            </div>
          )}

          {/* Divider */}
          <div className="border-t border-white/10 mb-8" />

          {/* Instructions */}
          <div className="space-y-6">
            <div className="text-center">
              <p className="font-body text-sm text-white/60 mb-4">
                Click the button below to open Venmo and send payment to:
              </p>
              <p className="font-heading text-xl text-white tracking-wide">
                @{venmoUsername}
              </p>
            </div>

            {/* Venmo Button */}
            <a
              href={venmoLink}
              target="_blank"
              rel="noopener noreferrer"
              className="venmo-btn w-full py-4 flex items-center justify-center gap-3 font-heading tracking-widest uppercase"
              data-testid="venmo-pay-button"
            >
              Open Venmo
              <ExternalLink size={18} strokeWidth={2} />
            </a>

            {/* Alternative Instructions */}
            <div className="bg-white/5 p-4 rounded">
              <p className="font-body text-xs text-white/40 text-center">
                Or search for <strong className="text-white/60">@{venmoUsername}</strong> in your Venmo app
              </p>
            </div>
          </div>

          {/* Note */}
          <p className="font-body text-xs text-white/30 text-center mt-8">
            Please include your name and selected package in the payment note.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VenmoModal;
